// extracted by mini-css-extract-plugin
export default {"container":"RuleConfiguratorBody_container__SF7v7"};